import React from "react";

export default function AAExperience() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold mb-8 text-center text-gray-800">
        நான் மது அருந்தத் தகுதியற்றவன்
      </h1>

      <div className="space-y-6 text-gray-800 text-justify leading-relaxed text-lg">
        <p>வணக்கம்,</p>
        <p>'நான் ஒரு குடிகாரன்'</p>

        <p>
          சென்னையில் பிறந்த பெருமிதத்தோடு வளர்ந்த நான் தன்னிறைவான வாழ்க்கையை மிக
          எளிமையாக எட்டி விடலாம் என்று பயணித்த எனக்கு நடைமுறை வாழ்க்கையில் எல்லா
          மனிதர்களுக்கும் இருக்கும் சிக்கல் எனக்கும் இருந்தது என்பதை காலப்போக்கில்
          உணர்ந்தாலும், தான் ஒரு நல்ல நிலைக்கு வந்து விட்டோம் அவை அவை அதனதன்
          தரத்தில் இருக்கிறது நமக்கு ஒன்றும் இனி எந்த கவலையும் இல்லை என்ற நிலையில்.
          ஆசைகள் பல்வேறு வகைகளில் வந்தாலும், ஒன்றைத் தவிர மற்றதை எல்லாவற்றையும்
          புறந்தள்ளிவிட்டு மதுவை மட்டும் பிரியத்துடன் அரவணைத்துக் கொண்டேன்.
        </p>

        <p>
          காலப்போக்கில் என் கதை கந்தளானது. உடனே ஒப்புக்கொள்ள மனம் இல்லை; என்னால்
          எல்லாவற்றையும் சரிசெய்து கொள்ள முடியும் என்ற மன உறுதி இருந்தாலும்
          நடைமுறைப்படுத்துவது மிகவும் கடினமாக இருந்தது. விளைவுகள் அதிகம் —
          தன்மதிப்பு தரம் தாழ்ந்தது, என்னால் புரிந்து கொள்ள முடியாத, இயல்பான
          யதார்த்தமான பிரச்சனைகளைக் கூட கையால முடியாத சூழ்நிலையில் தனி மனிதனாக
          தள்ளப்பட்டேன்.
        </p>

        <p>
          எளிமையான வார்த்தையில் சொல்ல வேண்டுமென்றால்: “என் மீதே எனக்கு அக்கறை இல்லாமல்
          போனது தான்.” என் மனநிலை சீர்கெட்டு பொறுப்பற்ற தன்மையை உருவாக்கியது. மனதை
          சீர்படுத்த நான் எடுத்துக்கொண்ட மருந்து ஆல்கஹால். எனக்கு நானே மருத்துவர் ஆனேன்.
          தற்காலிகமாக மனதை சீர்படுத்தியது உண்மைதான், ஆனால் தீர்வு தென்படவில்லை.
          மீண்டும் மது, மீண்டும் மீண்டும் மது — மது பழக்கம் அடிமைப்படுத்தியதை என்னால்
          உணர முடியாமல் போனது. அதன் விளைவாக வாழ்க்கை தடுமாற்றம் தொடர்ந்தது.
          இதனிடையே சில நேரங்களில் சரியான பாதையில் தேர்ந்தெடுத்து செல்வதில் உள்ளுணர்வு
          வழிகாட்ட வேண்டும் என மனம் போராடியது.
        </p>

        <p>
          மனம் போராட்டத்தின் தொடக்கம் மற்றும் எதிர்மறை சிந்தனைகளோடு ஆல்கஹாலிக்ஸ்
          அனானிமஸ் இயக்கத்தில் இருந்த நண்பரின் உதவியுடன் தஞ்சம் அடைந்தேன். ஆல்கஹாலிக்ஸ்
          அனானிமஸ் கூட்டத்தில் ஒவ்வொருவரின் தனிப்பட்ட அனுபவங்களின் மூலமாக நான் எந்த
          நிலையில் எப்படி எப்படிப்பட்ட நிலைகளில் எல்லாம் வாழ்க்கையை நடத்திக் கொண்டிருந்தேன்
          என்பதை பல சம்பவங்கள் கண்முன்னே வந்து போனது.
        </p>

        <p>
          என் கண்முன்னே உண்மைகளை உணர்ந்தவர்கள் எடுத்துக்காட்டாக வாழ்வதை பார்க்கிறேன்.
          பலன்கள் கண்கூடாக தெரிந்தது. முதல் புரிதலில் எனது உடல் மதுவை ஏற்றுக்கொள்ளும்
          தகுதி இழந்ததை அனுபவத்தில் ஒப்புக்கொண்டேன். அதன் அறிகுறிகள் — craving,
          obsession, allergy (ஏக்கம், மன ஆவேசம் மற்றும் ஒவ்வாமை) — இவைகளே குடி நோயின்
          தன்மைகள் என கூறப்படுகிறது.
        </p>

        <p>
          ஆகவே இனி எனது உடல் குடிக்கும் தகுதியை இழந்ததால், நான் மது அருந்துவதற்கு
          ஏற்றவன் அல்ல. <strong>(I am not fit to alcohol. I am unfit to alcohol.)</strong>{" "}
          2012 மார்ச் 22ல் ஆல்கஹாலிக்ஸ் அனானிமஸ் கூட்டத்தில் கலந்துகொண்ட நாள் முதல் இன்று
          வரை குடிக்க வேண்டிய அவசியமே இல்லாமல் போனதால் என் எல்லா சிக்கல்களும்
          சங்கடங்களும் தன்னியல்பாகவே கரைந்து போனது.
        </p>

        <p>
          இன்று சமூகத்தில் சராசரியான ஒரு மனிதர் வாழ்வது போல என்னால் எல்லாவற்றையும்
          எதிர்கொண்டு வாழ முடிகிறது. ஆனால் நான் ஒரு சராசரி மனிதன் அல்ல — ஒரு குடி
          நோயாளி. ஒரு முறை குடி நோயாளியாக அவன் கருதப்பட்டால், வாழ்நாள் முழுவதும் அவன்
          குடி நோயாளிதான் என கூட்டத்தில் பலமுறை நான் கேட்டிருக்கிறேன். அந்த சொல்லை
          பசுமரத்து ஆணியாக என் மனதில் பதிய வைத்துள்ளதால் எளிமையாக என்னை வைத்துக் கொள்ள
          முடிகிறது. ஒவ்வொரு நாளும் மகிழ்ச்சியாக வாழ முடிகிறது.
        </p>

        <p>
          இந்த வாழ்க்கையை கொடுத்த ஆல்கஹாலிக்ஸ் அனானிமஸ் இயக்கத்திற்கும், இயற்கைக்கும்
          நன்றிகள் பல.
        </p>
      </div>
    </div>
  );
}
